import { render } from "./CompSectionProfileComponent.vue?vue&type=template&id=46af5137&scoped=true"
import script from "./CompSectionProfileComponent.vue?vue&type=script&lang=js"
export * from "./CompSectionProfileComponent.vue?vue&type=script&lang=js"

import "./CompSectionProfileComponent.vue?vue&type=style&index=0&id=46af5137&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46af5137"]])

export default __exports__